module.exports = __webpack_public_path__ + "static/img/woman3.42318ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/woman3.png
// module id = Zcku
// module chunks = 2